(function () {
  'use strict';

  var compareProductCache = {};

  function getCompareProduct(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (compareProductCache[handle]) return compareProductCache[handle];

    compareProductCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product preview request failed');
      return response.json();
    });

    return compareProductCache[handle];
  }

  function initialiseComparison(root) {
    if (!root || root.dataset.ldComparisonReady === 'true') return;
    root.dataset.ldComparisonReady = 'true';

    root.querySelectorAll('[data-compare-card]').forEach(function (card) {
      var image = card.querySelector('[data-compare-image]');
      var imageWrap = card.querySelector('[data-compare-image-wrap]');
      var availability = card.querySelector('[data-compare-availability]');
      var swatches = card.querySelectorAll('[data-compare-finish]');
      var defaultSrc = image ? image.src : '';
      var defaultAlt = image ? image.alt : '';
      var defaultAvailability = availability ? availability.innerHTML : '';
      var defaultFinish = card.getAttribute('data-default-finish') || '';
      var mobileSelectedFinish = defaultFinish;

      function setPressed(finish) {
        swatches.forEach(function (swatch) {
          swatch.setAttribute(
            'aria-pressed',
            swatch.getAttribute('data-compare-finish') === finish ? 'true' : 'false'
          );
        });
      }

      function restoreDefault() {
        if (!image) return;
        image.src = defaultSrc;
        image.removeAttribute('srcset');
        image.alt = defaultAlt;
        if (availability) availability.innerHTML = defaultAvailability;
        setPressed(defaultFinish);
      }

      function previewSwatch(swatch, persistMobile) {
        if (!image || !swatch) return;

        var handle = swatch.getAttribute('data-product-handle');
        var finish = swatch.getAttribute('data-compare-finish') || '';
        var availabilityHtml = swatch.getAttribute('data-availability') || defaultAvailability;

        if (availability) availability.innerHTML = availabilityHtml;
        setPressed(finish);

        if (persistMobile) mobileSelectedFinish = finish;
        if (!handle) return;

        if (imageWrap) imageWrap.classList.add('is-loading');

        getCompareProduct(handle)
          .then(function (product) {
            var src = product.featured_image || (product.images && product.images[0]);
            if (src) {
              image.src = src;
              image.removeAttribute('srcset');
              image.alt = (product.title || finish + ' under cabinet light') + ' product image';
            }
          })
          .catch(function () {
            /* Keep the existing image if the live product preview cannot be loaded. */
          })
          .finally(function () {
            if (imageWrap) imageWrap.classList.remove('is-loading');
          });
      }

      function restoreMobileSelection() {
        var selected = card.querySelector('[data-compare-finish="' + mobileSelectedFinish + '"]');
        if (selected) previewSwatch(selected, false);
        else restoreDefault();
      }

      swatches.forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function () {
          if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) {
            previewSwatch(swatch, false);
          }
        });

        swatch.addEventListener('focus', function () {
          previewSwatch(swatch, false);
        });

        swatch.addEventListener('click', function () {
          var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
          previewSwatch(swatch, isTouch);
        });
      });

      card.addEventListener('mouseleave', function () {
        if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) {
          restoreDefault();
        }
      });

      card.addEventListener('focusout', function (event) {
        if (!card.contains(event.relatedTarget)) {
          if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
            restoreMobileSelection();
          } else {
            restoreDefault();
          }
        }
      });
    });
  }

  document.querySelectorAll('.ld-style-page').forEach(initialiseComparison);
})();
